<quick-card
  [routerLink]="['./chatbots']"
  [uid]="'chatbots-card'"
  [heading]="'Assistants'"
  [loader]="loader"
  [headingIconKey]="'psychology_alt'"
  [innerContentTemplate]="results"
  [matTooltip]="'Preview assistants available for use and configuration'"
></quick-card>

<ng-template #results let-content=content>
  {{content['countTotal']}}
</ng-template>
